import { AddBuildingsAction } from "../actions/AddBuildingsAction";
import { AddParcelsAction } from "../actions/AddParcelsAction";
import { FocusAction } from "../actions/FocusAction";
import { SetMarkersAction } from "../actions/SetMarkersAction";
import { SingletonAction } from "../actions/SingletonAction";
import { InspectionsLayer } from "../layers/selectable/InspectionsLayer";
import { Dispatcher } from "../../lib/dispatch";
import { Switchboard } from "../../lib/events";
import { None } from "../../lib/misc/option";
import { AnalyzeSalesRatioAction } from "../actions/AnalyzeSalesRatioAction";
import { SalesRatioLayer } from "../layers/selectable/SalesRatioLayer";
export class GSADispatcher extends Dispatcher {
    constructor(map, p_layer, s_layer, m_layer, b_layer, ctx_mgr) {
        super(map, p_layer, ctx_mgr);
        this.p_layer = p_layer;
        this.navigation_emitter = Switchboard.get_emitter('NAVIGATION');
        this.add_actions(new AddBuildingsAction(s_layer, p_layer), new AddParcelsAction(p_layer), new FocusAction(map, p_layer, b_layer, s_layer), new SetMarkersAction(map, p_layer, m_layer), new AnalyzeSalesRatioAction(map, p_layer), new SingletonAction());
    }
    async dispatch(msg) {
        const res = await super.dispatch(msg);
        if (!res.navigate)
            res.navigate = None.instance();
        res.navigate.map(strap => {
            if (!(this.p_layer instanceof InspectionsLayer || this.p_layer instanceof SalesRatioLayer))
                this.navigation_emitter.emit("navigate", strap);
        });
        return res;
    }
}
